<ng-select
        [items]="items"
        [loading]="loading"
        [clearable]="clearable"
        [searchable]="searchable"
        bindLabel="name"
        bindValue="id"
        [placeholder]="placeholder"
        [ngModel]="value"
        (ngModelChange)="onSelectionChange($event)"
        [disabled]="_disabled">

  <ng-template ng-label-tmp let-item="item">
    <div>{{ item.businessName }}<span *ngIf="item.taxCode"> - <small>{{ item.taxCode }}</small></span></div>
  </ng-template>

  <ng-template ng-option-tmp let-item="item">
    <div>{{ item.businessName }}<span *ngIf="item.taxCode"> - <small>{{ item.taxCode }}</small></span></div>
  </ng-template>

  <!-- Loading template -->
  <ng-option *ngIf="loading" [disabled]="true">
    Loading...
  </ng-option>

  <!-- Empty state template -->
  <ng-option *ngIf="!loading && items.length === 0 && parent" [disabled]="true">
    No items found
  </ng-option>

  <ng-option *ngIf="!parent" [disabled]="true">
    Please select a parent first
  </ng-option>
</ng-select>